import React from "react";
import { toast } from "react-toastify";
import { Input, Textarea } from "../../../components/form";
import { Button } from "../../../components/button";
import { useCreateReport } from "../hooks";
import { CustomerSelectSearch } from "../../customers/components";
import { formatDate } from "../../../helpers/date";

interface IProps {
  customerId?: number;
  onCompleted: () => void;
}

export const ReportForm: React.FC<IProps> = ({ customerId, onCompleted }) => {
  const { form, submit, loading } = useCreateReport({
    defaultValues: { customerId, weekStartDate: formatDate(new Date()) },
    onCompleted: () => {
      toast.success("Le rapport a été enregistré avec succès");
      form.reset({ customerId, weekStartDate: formatDate(new Date()) });
      onCompleted();
    },
  });

  return (
    <div className="flex flex-wrap gap-3 items-end">
      {!customerId && (
        <CustomerSelectSearch form={form} name="customerId" label="Client" />
      )}
      <Input
        label="Semaine du"
        type="date"
        className="w-full"
        {...form.register("weekStartDate", { required: "Date requise" })}
      />
      <Textarea
        label="Contenu"
        className="w-full"
        {...form.register("content", { required: "Contenu requis" })}
        placeholder="Actions SEO réalisées cette semaine..."
      />
      <Button onClick={submit} loading={loading} disabled={loading}>
        Enregistrer le rapport
      </Button>
    </div>
  );
};
